import * as React from 'react';
import { Dialog, DialogFooter, IDialogProps } from '@fluentui/react';
import LoadingIndicator from './LoadingIndicator';

export interface ILoadingResultDialogProps extends Omit<IDialogProps, 'children'> {
    isLoading: boolean;
    loadingLabel?: string;
    footer?: React.ReactNode;
    /** Fast højde på indholdsområdet, så dialogen ikke "hopper" når data er indlæst (fx forhåndsvisninger) */
    contentHeight?: string | number;
}

const LoadingResultDialog: React.FunctionComponent<React.PropsWithChildren<ILoadingResultDialogProps>> = ({ isLoading, loadingLabel, footer, contentHeight, children, dialogContentProps, ...dialogProps }) => {
    if (contentHeight === undefined) {
        return (
            <Dialog
                hidden={false}
                {...dialogProps}
                dialogContentProps={{ ...dialogContentProps, subText: isLoading ? undefined : dialogContentProps?.subText }}>
                {isLoading ? <LoadingIndicator label={loadingLabel} /> : children}
                {!isLoading && footer && <DialogFooter>{footer}</DialogFooter>}
            </Dialog>
        );
    }

    // Fast højde: undertekst, indholdsområde og footer fylder det samme under indlæsning som bagefter
    return (
        <Dialog
            hidden={false}
            {...dialogProps}
            dialogContentProps={dialogContentProps}>
            <div style={{ height: contentHeight, display: "flex", flexDirection: "column", justifyContent: isLoading ? "center" : undefined }}>
                {isLoading ? <LoadingIndicator label={loadingLabel} /> : children}
            </div>
            {footer && <div style={{ visibility: isLoading ? "hidden" : undefined }}><DialogFooter>{footer}</DialogFooter></div>}
        </Dialog>
    );
};

export default LoadingResultDialog;
